import { render, staticRenderFns } from "./round-edit.vue?vue&type=template&id=a0c49260&"
import script from "./round-edit.vue?vue&type=script&lang=js&"
export * from "./round-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports